// Sdílené konstanty pro modul tiketů.

export const STAV_TIKET_LABEL = {
  novy:       'Nový',
  prirazeno:  'Přiřazeno',
  v_reseni:   'V řešení',
  ceka:       'Čeká',
  uzavreno:   'Uzavřeno',
  stornovano: 'Stornováno',
};

export const STAV_TIKET_COLOR = {
  novy:       '#3b82f6',
  prirazeno:  '#8b5cf6',
  v_reseni:   '#d97706',
  ceka:       '#6b7280',
  uzavreno:   '#4b5563',
  stornovano: '#9ca3af',
};

// Štítek role přihlášeného uživatele podle payloadu tokenu (dispečer s muze_resit = „Dispečer · technik“).
export function roleStitek(payload) {
  if (!payload) return null;
  if (payload.role === 'dispecer' && (payload.muze_resit ?? false)) return 'Dispečer · technik';
  return ROLE_LABEL[payload.role] || payload.role;
}

export const ROLE_LABEL = {
  technik:  'Technik',
  dispecer: 'Dispečer',
  admin:    'Admin',
};

export const VYSLEDEK_LABEL = {
  vyreseno:    'Vyřešeno',
  bude_vyjezd: 'Bude výjezd',
  cekame:      'Čekáme',
};

export const CEKA_DUVODY = [
  'chybí součinnost zákazníka',
  'není přístup do prodejny nebo k zařízení',
  'chybí přístupové údaje',
  'čeká se na schválení nákladů',
  'čeká se na náhradní díl mimo sjednanou skladovou zásobu',
];

export const SLA_BARVA = {
  zelena: '#16a34a', oranzova: '#ea580c', cervena: '#dc2626', seda: '#6b7280',
  splneno: '#16a34a', nesplneno: '#dc2626',
};
